// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"90ce6e4d","732":"404cb8a6"}[chunkId] + ".chunk.js";
};